import Grid from '@mui/material/Grid2';
import { ComponentProps, ReactNode } from 'react';

type GridItemProps = ComponentProps<typeof Grid>;

export type CardsGridItemProps = {
  /** Responsive column span (pair with CardsGrid `columns`). */
  size: GridItemProps['size'];
  children: ReactNode;
};

/**
 * Single cell in a CardsGrid. Keeps item size API consistent across features.
 */
export function CardsGridItem({ size, children }: CardsGridItemProps) {
  return <Grid size={size}>{children}</Grid>;
}
